import { BANNED_URLS } from "../constants/assistant-config";

export const getPortalRootNode = () => {
  return document?.querySelector('#root');
};

export const getStickyATCElement = () => {
  // Query elements matching the markup added by the Sticky component
  const buyboxMatch = document.querySelector(
    'div[data-component^=buybox\\:Buybox\\:v] [style^=min-height] > [class*=sticky]'
  );
  const applianceBuyboxMatch = document.querySelector(
    'div[data-component^=buybox\\:MajorApplianceBuyBox\\:v] [style^=min-height] > [class*=sticky]'
  );
  const buyboxActionsMatch = document.querySelector(
    'div[data-component^=buybox\\:BuyboxActions\\:v] [style^=min-height] > [class*=sticky]'
  );
  const buyboxSimpleMatch = document.querySelector(
    'div[data-component^=Buybox] [style^=min-height] > [class*=sticky]'
  );

  // Use the more specific section if available
  if (buyboxActionsMatch) return buyboxActionsMatch;

  if (applianceBuyboxMatch) return applianceBuyboxMatch;

  if (buyboxSimpleMatch) return buyboxSimpleMatch;

  // Use the generic (older) version as fallback
  if (buyboxMatch) return buyboxMatch;

  return null;
};

export const getPath = () => {
  return typeof window !== 'undefined' ? new URL(window.document.documentURI).pathname : '';
};

export const getPageType = () => {
  const pathArray = getPath()?.split('/') || [];

  if (pathArray[1] === 'c') {
    return 'Content';
  }
  if (pathArray[1] === 'p') {
    return 'PIP';
  }
  if (pathArray[1] === 's' || pathArray[1] === 'b') {
    return 'PLP';
  }
  return 'Home';
};

export const getSessionId = () => {
  const FALLBACK_SESSION_ID = 'fallback-sessionId';
  return (window !== undefined
    ? window?.cookieUtils?.readBrowserCookie('thda.s')
    : FALLBACK_SESSION_ID
  ) || FALLBACK_SESSION_ID;
};

export const getIsCompatiblePage = () => {
  const currentPageType = getPageType();
  const currentPath = getPath();

  if (BANNED_URLS.includes(currentPath)) {
    return false;
  }

  return !(currentPageType === 'Home' && currentPath !== '/');
};

export const nrTrack = (actionName, actionObject) => {
  if (typeof window !== 'undefined' && window.newrelic && actionName) {
    window.newrelic.addPageAction(actionName, actionObject);
  }
};
